import * as yup from "yup";

export const validations = {
  idTipoTelefono: yup
    .string()
    .required("Campo requerido"),
  idOperadora: yup
    .string()
    .required("Campo requerido"),
  numero: yup
    .string()
    .required("Campo requerido"),
};
